import { startTransition, useEffect } from 'react'

export default function useServerSideStore(storeCreator: () => void, clear?: () => void): void {
  if (typeof window === 'undefined') {
    storeCreator()
    return
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    startTransition(() => {
      storeCreator()
    })

    return (): void => clear?.()
  })
}
